import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Col, Row, Button, Label, Card, CardBody } from 'reactstrap';
import './billing.scss';
import fileSaver from 'file-saver';
import TaskTableView from './TableView/index';
import FilterFormTypeOne from '../../components/ReusableComponents/FilterFormTypeOne/index';
import { viewPage, downloadBillingDetails, fetchCorrespondentListBilling } from './action';
import { MODAL_TYPE_FORM } from '../../constants';
import { REQUEST_BODY, DATE_TEXT } from './constants';
import CorporateModal from '../../components/UI/CorporateModal';
import { setAppliedFilter, deleteAppliedFilters, deleteEntityFilter, getRequestBody, getRequestBodyList } from './helper'
import { Preloading } from '../../components/UI/Preloader/action';
import { setPageView } from '../../components/GoogleAnalytics/index';
class BillingComponent extends Component {
    constructor() {
        super();
        this.state = {
            loading: true,
            popoverOpen: false,
            billingTableData: {
                billingFilterResponses: []
            },
            selectedEntity: [],
            toDate: null,
            fromDate: null,
            appliedFilters: [],
            showModal: false,
            body: null,
            clearAllButton: null,
            modalType: MODAL_TYPE_FORM,
            modalCloseHandler: () => { },
        }
    }
    componentDidMount() {
        this.props.fetchCorrespondentListBilling()
        this.setState({
            loading: true
        });
        this.props.viewPage(REQUEST_BODY);
        setPageView('/Admin/billing', document.location.href)
    }
    componentDidUpdate(prevProps) {
        if (this.props.billingData !== prevProps.billingData) {
            this.props.preloading(false)
            this.setState({
                loading: false,
                billingTableData: this.props.billingData
            });
        }
        if (this.props.downloadExcel !== prevProps.downloadExcel) {
            var blob = new Blob([this.props.downloadExcel], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' });
            fileSaver.saveAs(blob, 'Billing_Data.xlsx');
        }
        if (this.props.correspondentList !== prevProps.correspondentList) {

        }
    }
    toggle = () => {
        this.setState({
            popoverOpen: !this.state.popoverOpen,
            applyFlag: false
        });
    }
    onCompletedFetchPage = (pageNo, pageSize, sorted) => {
        this.setState({
            loading: true
        });
        const requestBody = {
            pageNo: pageNo,
            pageSize: pageSize,
            sorted: sorted
        }
        this.props.viewPage(requestBody);
    }
    billingFilterCallBack = (selectedEntityData, dateFilter) => {
        const tempAppliedFilter = setAppliedFilter(selectedEntityData, dateFilter);
        let clearButton;
        if (tempAppliedFilter.length > 0) {
            clearButton = <Button className="filter-item filter-item-btn-clear" color="link" size="xs" onClick={this.handleClearAll}>Clear All</Button>
            this.toggle();
        } else {
            clearButton = null
        }
        this.setState({
            toDate: dateFilter.toDate,
            fromDate: dateFilter.fromDate,
            selectedEntity: selectedEntityData,
            appliedFilters: tempAppliedFilter,
            clearAllButton: clearButton
        })
        const requestBody = getRequestBodyList(REQUEST_BODY, selectedEntityData, dateFilter.toDate, dateFilter.fromDate)
        this.props.viewPage(requestBody);
        this.props.preloading(true)
    }
    handleClearAll = () => {
        this.setState({
            appliedFilters: [],
            toDate: null,
            fromDate: null,
            selectedEntity: [],
            clearAllButton: null
        }, () => {
            const selectedEntityDetails = []
            const requestBody = getRequestBodyList(REQUEST_BODY, selectedEntityDetails, this.state.toDate, this.state.fromDate)
            this.props.viewPage(requestBody);
            this.props.preloading(true)
        })

    }
    toggleModal = () => {
        this.setState(prevState => ({
            showModal: !prevState.showModal,
            body: null
        }))
    }
    handleRemoveFilter = (removeFilter) => {
        let clearButton, toDate = this.state.toDate, fromDate = this.state.fromDate;
        const removeFilterList = deleteAppliedFilters(removeFilter, this.state.appliedFilters);
        if (removeFilterList.length > 0) {
            clearButton = <Button className="filter-item filter-item-btn-clear" color="link" size="xs" onClick={this.handleClearAll}>Clear All</Button>
        } else {
            clearButton = null
        }
        if (removeFilter.value === DATE_TEXT) {
            this.setState({
                toDate: null,
                fromDate: null
            })
            fromDate = null
            toDate = null
        } else {
            const removeEntityFilterList = deleteEntityFilter(this.state.selectedEntity, removeFilter);
            this.setState({
                selectedEntity: removeEntityFilterList
            })
            toDate = this.state.toDate
            fromDate = this.state.fromDate
        }
        this.setState({
            appliedFilters: removeFilterList,
            clearAllButton: clearButton
        });
        const requestBody = getRequestBodyList(REQUEST_BODY, this.state.selectedEntity, toDate, fromDate)
        this.props.viewPage(requestBody);

    }
    handleDownloadExcel = () => {
        let requestBody;
        if (this.state.selectedEntity) {
            requestBody = getRequestBody(this.state.selectedEntity, this.state.toDate, this.state.fromDate)
        } else {
            requestBody = getRequestBody([], this.state.toDate, this.state.fromDate)
        }
        this.props.downloadBillingExcel(requestBody)
    }
    render() {
        return (
            <Col className="position-relative">
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h4 className="mb-0">Completed Tasks ({(this.state.billingTableData.billingFilterResponses) ? this.state.billingTableData.billingFilterResponses.length : 0})</h4>
                    <div className="filter-wrapper">
                        <Button id="Popover1" className="btn-icon btn-filter" outline size="sm" color="primary" onClick={this.toggle}>
                            <i className="icon-filter"></i>
                        </Button>
                        <Button className="btn-icon btn-filter ml-3" outline size="sm" color="primary" onClick={this.handleDownloadExcel}><i className="icon-download"></i></Button>
                    </div>
                </div>
                <div className={this.state.popoverOpen ? "position-absolute popover-billing d-block bg-light p-3" : "position-absolute filter-popover d-none p-3"}>
                    <FilterFormTypeOne multiselectTitle='Partner Name' dateFilterType="Approved On" correspondentList={this.props.correspondentList} hideFilterCallback={this.toggle} filterCallback={this.billingFilterCallBack} dateFilters={{ toDate: this.state.toDate, fromDate: this.state.fromDate }}
                        selectedEntity={this.state.selectedEntity} />
                </div>
                <div className="row no-gutters mb-3 d-flex flex-column flex-sm-row">
                    <Label className="filter-title col-sm-3 pr-0">Applied Filters :</Label>
                    <div className="col-sm-21 pl-0 filter d-flex flex-wrap align-items-center">
                        {this.state.appliedFilters.map(p => {
                            return (
                                <span key={p.value} className="filter-item d-flex align-items-center mr-2 mb-2">
                                    {p.label} <i className="icon-close" onClick={() => this.handleRemoveFilter(p)}></i>
                                </span>
                            )
                        })}
                        {this.state.clearAllButton}
                    </div>
                </div>
                <Card>
                    <CardBody>
                        <Row>
                            <Col>
                                <TaskTableView data={this.state.billingTableData}
                                    loading={this.state.loading}
                                    onFetchPage={this.onCompletedFetchPage} />
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
                <CorporateModal toShow={this.state.showModal}
                    modalClosed={this.state.modalCloseHandler}
                    modalType={this.state.modalType}
                    body={this.state.body}
                    title={this.state.modalTitle} />
            </Col >
        )
    }
}
const mapStateToProps = (state, ownProps) => ({
    billingData: state.correspondentBilling.billingPaginatedDataSuccess,
    downloadExcel: state.correspondentBilling.downloadBillingExcel,
    correspondentList: state.correspondentBilling.correspondentListDetails,
    correspondentListFailure: state.correspondentBilling.correspondentListDetailsFailure
})

const mapDispatchToProps = (dispatch) => ({
    viewPage: (data) => { dispatch(viewPage(data)) },
    downloadBillingExcel: (data) => { dispatch(downloadBillingDetails(data)) },
    fetchCorrespondentListBilling: () => { dispatch(fetchCorrespondentListBilling()) },
    preloading: (isPreloading) => { dispatch(Preloading(isPreloading)); }
});
export default connect(mapStateToProps, mapDispatchToProps)(BillingComponent);
